// Generated by CoffeeScript 2.7.0
var AddRedPacketQuotasModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import SelectUserPopover from 'trunks/vue/admin/components/settings/select_user_popover.js';

export default AddRedPacketQuotasModal = Vue.extend({
  components: {
    'modal': Modal,
    'select-user-popover': SelectUserPopover
  },
  props: {
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      selectedUser: null,
      userValid: true,
      allocatedAmountValid: true,
      remark: '',
      allocatedAmount: ''
    };
  },
  template: `<modal title='新增' extendClass="add-red-packet-quotas-modal" ref="modal">
  <div class="modal-body">
    <div class="field-list-two-item">
      <div class="form-field required" :class="{'has-error': !userValid }">
        <div class="form-field-head">
          <div class="form-field-title">选择用户</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
          <select-user-popover :initialSelectedUser="selectedUser"
                               @valueChanged="userValueChangedFunc" />
          </div>
          <div class="message">请选择用户</div>
        </div>
      </div>
      <div class="form-field required" :class="{'has-error': !allocatedAmountValid }">
        <div class="form-field-head">
          <div class="form-field-title">红包额度配置</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input class="valid-input" type="number" v-model.number="allocatedAmount">
          </div>
          <div class="message">请输入红包额度</div>
        </div>
      </div>
      <div class="form-field">
        <div class="form-field-head">
          <div class="form-field-title">备注</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="text" v-model="remark">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='modalCancel'>取消</button>
    <button @click='doRequest'>确定</button>
  </div>
</modal>`,
  watch: {
    allocatedAmount: function(val) {
      this._getValid('allocatedAmountValid', 'allocatedAmount');
      return this._testAllocatedAmount(val);
    }
  },
  methods: {
    modalCancel: function() {
      return this.$refs.modal.close();
    },
    doRequest: function() {
      var data;
      this._validate();
      if (!(this.allocatedAmountValid && this.userValid)) {
        return;
      }
      data = {
        red_packet_quota: {
          user_id: this.selectedUser.id
        },
        red_packet_allocation: {
          user_id: this.selectedUser.id,
          allocated_amount: this.allocatedAmount,
          remark: this.remark
        }
      };
      return Skylark.Libs.Ajax.post(Skylark.Helpers.UrlHelper.adminUrlFor("/settings/red_packet_quotas"), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: (data) => {
          Skylark.Bridge.newAlertify('操作成功', {
            type: 'success'
          });
          this.callback();
          return this.modalCancel();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('操作失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    userValueChangedFunc: function(selectedUser) {
      this.selectedUser = selectedUser;
      return this._getValid('userValid', 'selectedUser');
    },
    _getValid: function(valid, param) {
      return this[valid] = this[param] ? true : false;
    },
    _validate: function() {
      this._getValid('userValid', 'selectedUser');
      return this._getValid('allocatedAmountValid', 'allocatedAmount');
    },
    _testAllocatedAmount: function(val) {
      var reg;
      reg = /^(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/;
      if (!reg.test(val)) {
        if (val) {
          return this.allocatedAmount = Math.floor(Math.abs(val) * 100) / 100;
        } else {
          return this.allocatedAmount = null;
        }
      }
    }
  }
});
